'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _List = require('components/List/List');

var _List2 = _interopRequireDefault(_List);

var _RecipientProjectsListHeader = require('components/Statistics/RecipientProjectsListHeader/RecipientProjectsListHeader');

var _RecipientProjectsListHeader2 = _interopRequireDefault(_RecipientProjectsListHeader);

var _RecipientProjectsListItem = require('components/Statistics/RecipientProjectsListItem/RecipientProjectsListItem');

var _RecipientProjectsListItem2 = _interopRequireDefault(_RecipientProjectsListItem);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var StatisticsRecipientProjectsList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    activeOrder: state.statistics.recipientProjectsActiveOrder,
    order: state.statistics.recipientProjectsOrder
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(StatisticsRecipientProjectsList, _Component);

  function StatisticsRecipientProjectsList() {
    (0, _classCallCheck3.default)(this, StatisticsRecipientProjectsList);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsRecipientProjectsList.__proto__ || (0, _getPrototypeOf2.default)(StatisticsRecipientProjectsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsRecipientProjectsList, [{
    key: 'reorder',
    value: function reorder(name) {
      this.props.recipientProjectsReorder(name);
    }
  }, {
    key: 'goProjectStats',
    value: function goProjectStats(project) {
      this.context.push('/statistics/recipient/' + project.recipientId + '/project/' + project.id + '?referrerRecipient=' + this.props.recipientId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          loading = _props.loading,
          projects = _props.projects,
          activeOrder = _props.activeOrder,
          order = _props.order,
          recipientId = _props.recipientId;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _List2.default,
          null,
          _react2.default.createElement(_RecipientProjectsListHeader2.default, {
            activeOrder: activeOrder,
            order: order,
            onReorder: this.reorder
          }),
          projects.map(function (project) {
            return _react2.default.createElement(_RecipientProjectsListItem2.default, {
              key: project.id + '-' + project.recipientId,
              project: project,
              recipientId: recipientId,
              onClick: _this2.goProjectStats
            });
          })
        ),
        _react2.default.createElement(_Loader2.default, { show: loading, alignCenter: true })
      );
    }
  }]);
  return StatisticsRecipientProjectsList;
}(_react.Component), _class3.propTypes = {
  activeOrder: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  order: _propTypes2.default.object,
  projects: _propTypes2.default.array.isRequired,
  recipientId: _propTypes2.default.number,
  recipientProjectsReorder: _propTypes2.default.func
}, _class3.defaultProps = {
  projects: []
}, _class3.contextTypes = {
  push: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'reorder', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reorder'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'goProjectStats', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'goProjectStats'), _class2.prototype)), _class2)) || _class);
exports.default = StatisticsRecipientProjectsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/StatisticsRecipientProjectsList/StatisticsRecipientProjectsList.js
// module id = 2222
// module chunks = 1